import {bleskAuthStore, parseJwtUser} from '@blesk-frontend/auth';
import {useLocation} from '@tanstack/react-router';
import {useEffect} from 'react';
import ymOriginal from 'react-yandex-metrika';

const ym = import.meta.env.PROD ? ymOriginal : () => {};

/**
 *
 */
export const useYandexMetrikaIdentify = () => {
  const {href} = useLocation();
  const {token} = bleskAuthStore();

  useEffect(() => {
    ym('hit', href);
  }, [href]);

  useEffect(() => {
    if (token) {
      const user = parseJwtUser(token);

      if (!user) {
        return;
      }

      ym('setUserID', user.id);

      ym('userParams', {
        fullName: user.fullName,
        email: user.email,
        teamId: user.teamId,
      });
    }
  }, [token]);
};
